import { actions } from '@/modules/SiteList/store/actions';
import { SiteListState, state } from '@/modules/SiteList/store/state';
import { mutations } from '@/modules/SiteList/store/mutations';
import { getters } from '@/modules/SiteList/store/site-list-getters';

const PreavisSiteListModule = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};

export default PreavisSiteListModule;
export type { SiteListState };
